export default {
  addrOne: 'EMPIRE CINEMAS, JAZAN',
  welcome: 'WELCOME TO EMPIRE CINEMAS!',
  EmpireCinemas: 'Empire Cinemas',
  LocationName: 'Location Name',
  Gizan: 'Gizan',
  Jizan: 'Jizan',
  Jazan: 'Jazan',
  EmpireCinemasGizan: 'Empire Cinemas-Gizan',
  JizanAlRashidMall: 'Jazan-Al Rashid Mall',
  JazanAlRashidMall: 'Jazan-Al Rashid Mall',
  GizanAlRashidMall: 'Gizan-Al Rashid Mall',
  WelcomeToEmpireCinemas: 'WELCOME TO EMPIRE CINEMAS!',
  PleaseSelectYourPrefferedLanguage: 'PLEASE SELECT YOUR PREFERRED LANGUAGE',
  Arabic: 'Arabic',
  PickUpYourTicket: 'Pick up your ticket',
  BookYourShow: 'Book your show',
  LetsGetYouYourTickets: 'LET’S GET YOU YOUR TICKETS!',
  PleaseEnterYourBookingId: 'PLEASE ENTER YOUR BOOKING ID',
  Proceed: 'Proceed',
  Back: 'Back',
  SelectMovie: 'Select Movie',
  Exit: 'Exit',
  SelectShowTimes: 'Select Show Times',
  Synopsis: 'Synopsis',
  Actors: 'Actors',
  DirectedBy: 'Directed by',
  FORMAT: 'FORMAT',
  PICKADATE: 'PICK A DATE',
  CHOOSEYOURSHOWTIME: 'CHOOSE YOUR SHOW TIME',
  Next: 'Next',
  SelectSeat: 'Select Seat',
  FoodAndDrinks: 'Food and drinks',
  YourSelection: 'Your Selection',
  Available: 'Available',
  Unavailable: 'Unavailable',
  PleasePickASeatCategory: 'PLEASE PICK A SEAT CATEGORY',
  SelectYourSeat: 'SELECT YOUR SEATS!',
  GrabABite: 'GRAB A BITE!',
  SomethingToSnackOn: 'SOMETHING TO SNACK ON?',
  ConfirmOrder: 'Confirm Order',
  SkipToSummary: 'SKIP TO SUMMARY',
  AlmostDoneSignInToConfirmYourBooking: 'ALMOST DONE - SIGN IN TO CONFIRM YOUR BOOKING!',
  YourEmail: 'Your Email',
  YourContactNo: 'Your Contact No',
  Confirmation: 'CONFIRMATION',
  SubTotal: 'SUB-TOTAL',
  Tickets: 'Tickets',
  Checkout: 'Checkout',
  PrintTickets: 'Print Tickets',
  Cinema: 'CINEMA',
  Screen: 'SCREEN',
  Time: 'TIME',
  Seats: 'SEATS',
  ChangeLanguage: 'Change Language',
  firstRow: 'FIRST ROW',
  bachelor: 'BACHELOR',
  family: 'FAMILY',
  LetsGetYourTicket: "LET'S GET YOUR TICKETS!",
  ReceiptNo: 'Receipt No',
  ReleaseDate: 'Release Date',
  PickupCode: 'Pick Up Code',
  Home: 'HOME',
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
  Sunday: 'Sunday',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Today: 'Today',
  Tomorrow: 'Tomorrow',
  AM: 'AM',
  PM: 'PM',
  Normal: 'Normal',
  English: 'English',
  Items: 'ITEMS',
  ThePhoneNumberFieldIsRequired: 'The phone number feild is required',
  TheUsernameFeildIsRequired: 'The username feild is required',
  ThePasswordFeildIsRequired: 'The password feild is required',
  ForgorPassword: 'Forgot Password',
  BookingFee: 'Booking Fee',
  IncludesAllTaxesAndFees: 'Includes all taxes and fees',
  IAgree: 'I Agree',
  Cancel: 'Cancel',
  RulesOfEntry: 'Rules Of Entry'
}



// WEBPACK FOOTER //
// ./src/helper/ln/en.js